
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'Settings-text--terms-and-conditions'
})

export default class SettingsTextTermsAndConditions extends Vue { }
